/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./OrderMessage.vue?vue&type=template&id=3617d874&scoped=true&"
import script from "./OrderMessage.vue?vue&type=script&lang=js&"
export * from "./OrderMessage.vue?vue&type=script&lang=js&"
import style0 from "./OrderMessage.vue?vue&type=style&index=0&id=3617d874&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3617d874",
  null
  
)

export default component.exports